import IProduct from "../entities/IProduct";

export const PRODUCT_STATUS = {
  DRAFT: 0,
  PUBLISHED: 1,
} as const;

export const isProductPublished = (
  product: Pick<IProduct, "estatusId"> | null | undefined
): boolean => Number(product?.estatusId) === PRODUCT_STATUS.PUBLISHED;
